import { render, staticRenderFns } from "./DishesDetailPage.vue?vue&type=template&id=6199a2c2&"
import script from "./DishesDetailPage.vue?vue&type=script&lang=js&"
export * from "./DishesDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DishesDetailPage.vue?vue&type=style&index=0&id=6199a2c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports